import React, { useState, useEffect, useCallback } from 'react';
import { fetchConToken } from 'helpers/fetch';
import AsyncSelect from 'react-select/async';
import { useTranslation } from "react-i18next";
import { getDataSession } from 'views/Utils/Common';
import Swal from 'sweetalert2';

const FormCategoriaXLotes = ({ data, HandleChangePrincipal, disabled, HandlePredictCat, categorias, SetCategorias, Save, CloseModal, tienda, sucursal, claveCategoria }) => {
    const { t } = useTranslation("common");
    return (<div className='row'>
        <div className='espacio30px' />
        <CategoriaForm
            data={data}
            disabled={disabled}
            HandleChangePrincipal={HandleChangePrincipal}
            categorias={categorias}
            SetCategorias={SetCategorias}
            tienda={tienda}
            sucursal={sucursal}
            HandlePredictCat={HandlePredictCat}
            claveCategoria={claveCategoria}
        />
        <div className='espacio5px' />
        <div className='row'>
            <div className='col-sm-8' />
            <div className='col-sm-2'>
                <button className='btn btn-outline-danger' onClick={CloseModal}>
                    <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width='20'
                        height='20'
                        fill='currentColor'
                        className='bi bi-x-lg'
                        viewBox='0 0 16 16'
                    >
                        <path d='M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z' />
                    </svg>
                    &nbsp; &nbsp; {t('app.botones.cancelar')}
                </button>
            </div>
            <div className='col-sm-2'>
                <button className='btn btn-outline-success' onClick={Save}>
                    <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width='20'
                        height='20'
                        fill='currentColor'
                        className='bi bi-check-lg'
                        viewBox='0 0 16 16'
                    >
                        <path d='M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z' />
                    </svg>
                    &nbsp; {t('app.botones.guardar')}
                </button>
            </div>
        </div>
    </div>);
}

const FormCategoria = ({ data, HandleChangePrincipal, disabled, HandlePredictCat, categorias, tienda, sucursal, claveCategoria, Save, CloseModal }) => {
    const { t } = useTranslation("common");
    let [atributos, setAtributos] = useState([]);
    let [etiquetas, setEtiquetas] = useState([]);
    const [articulo, setArticulo] = useState(data);
    let [_categorias, handleCategorias] = useState(categorias || []);

    function handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        setArticulo({
            ...articulo,
            [name]: value
        });
    }

    const onClick = () => {
        if (tienda !== 'MERCADOLIBRE') {
            articulo.etiquetas = etiquetas;
            articulo.categorias = _categorias;
            articulo.peso = articulo.peso ? articulo.peso : '0';
            articulo.ancho = articulo.ancho ? articulo.ancho : '0';
            articulo.altura = articulo.altura ? articulo.altura : '0';
            articulo.longitud = articulo.longitud ? articulo.longitud : '0';
            setArticulo({
                ...articulo,
                categorias: _categorias,
                etiquetas: etiquetas
            });
        }

        Save(articulo);
    }

    useEffect(() => {
        if (tienda !== 'MERCADOLIBRE') {
            if (data.atributos_Combinacion && data.atributos_Combinacion.length > 0) data.atributos_Combinacion.forEach(e => {
                var temp = atributos.filter(x => x.clave_Atributo === e.clave_Atributo);
                if (!(temp?.length > 0)) setAtributos([...atributos, { clave_Atributo: e.clave_Atributo, nombre: e.nombre, sucursal_Id: e.sucursal_Id }]);
            });
            else if (data.articulo_Variantes && data.articulo_Variantes.length > 0) data.articulo_Variantes.forEach(variant => {
                if (variant.atributos_Combinacion && variant.atributos_Combinacion.length > 0) variant.atributos_Combinacion.forEach(e => {
                    var temp = atributos.filter(x => x.clave_Atributo === e.clave_Atributo);
                    if (!(temp?.length > 0)) setAtributos([...atributos, { clave_Atributo: e.clave_Atributo, nombre: e.nombre, sucursal_Id: e.sucursal_Id }]);
                });
            });

            if (data.etiquetas?.length > 0) data.etiquetas.forEach(e => setEtiquetas([...etiquetas, { clave_Etiqueta: e.clave_Etiqueta, nombre: e.nombre, sucursal_Id: e.sucursal_Id }]));
        }
    }, []);

    return (<div style={{ display: 'flex', flexDirection: 'column', maxHeight: '80vh' }}>
        <div className='espacio30px' />
        <div style={{ overflowY: 'auto', overflowX: 'hidden', flex: '1 1 auto', minHeight: '65vh' }}>
            {tienda === 'MERCADOLIBRE' ? <CategoriaForm
                data={data}
                disabled={disabled}
                HandleChangePrincipal={HandleChangePrincipal}
                categorias={_categorias}
                SetCategorias={handleCategorias}
                tienda={tienda}
                sucursal={sucursal}
                HandlePredictCat={HandlePredictCat}
                claveCategoria={claveCategoria}
            /> : <div className='col-md-12' style={{ display: 'grid' }}>
                <div className='card mb-3 '>
                    <div className='espacio15px' />
                    <div className='card-body text-start'>
                        <CategoriaList
                            data={data}
                            disabled={disabled}
                            HandleChangePrincipal={HandleChangePrincipal}
                            categorias={_categorias}
                            SetCategorias={handleCategorias}
                            tienda={tienda}
                            sucursal={sucursal}
                            HandlePredictCat={HandlePredictCat}
                            claveCategoria={claveCategoria}
                        />
                    </div>
                </div>
                <div className='espacio5px' />
                <div className='card card-body text-start'><AtributoList atributos={atributos} SetAtributos={setAtributos} sucursal={sucursal} /></div>
                <div className='espacio5px' />
                <div className='card card-body text-start'><EtiquetasList etiquetas={etiquetas} SetEtiquetas={setEtiquetas} sucursal={sucursal} /></div>
                <div className='espacio5px' />
                <div className='card card-body text-start'><MedidasEnvio articulo={articulo} handleInputChange={handleInputChange} tienda={tienda} sucursal={sucursal} /></div>
                <div className='espacio5px' />
            </div>}
        </div>
        <div className='espacio5px' />
        <div className='row'>
            <div className='col-sm-8' />
            <div className='col-sm-2'>
                <button className='btn btn-outline-danger' onClick={CloseModal}>
                    <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width='20'
                        height='20'
                        fill='currentColor'
                        className='bi bi-x-lg'
                        viewBox='0 0 16 16'
                    >
                        <path d='M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z' />
                    </svg>
                    &nbsp; &nbsp; {t('app.botones.cancelar')}
                </button>
            </div>
            <div className='col-sm-2'>
                <button className='btn btn-outline-success' onClick={onClick}>
                    <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width='20'
                        height='20'
                        fill='currentColor'
                        className='bi bi-check-lg'
                        viewBox='0 0 16 16'
                    >
                        <path d='M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z' />
                    </svg>
                    &nbsp; {t('app.botones.guardar')}
                </button>
            </div>
        </div>
    </div>);
}

const CategoriaForm = ({ data, HandleChangePrincipal, disabled, HandlePredictCat, categorias, SetCategorias, tienda, sucursal, claveCategoria }) => {
    return (<div className='row'>
        <div className='col-md-12' style={{ display: 'grid' }}>
            <div className='card mb-3 '>
                <div className='espacio15px' />
                <div className='card-body text-start'>
                    <CategoriaList
                        data={data}
                        HandleChangePrincipal={HandleChangePrincipal}
                        disabled={disabled}
                        HandlePredictCat={HandlePredictCat}
                        categorias={categorias}
                        SetCategorias={SetCategorias}
                        tienda={tienda}
                        sucursal={sucursal}
                        claveCategoria={claveCategoria}
                    />
                </div>
                <div className='espacio15px' />
            </div>
        </div>
    </div>);
}

const CategoriaList = ({ data, HandleChangePrincipal, disabled, HandlePredictCat, categorias, SetCategorias, tienda, sucursal, claveCategoria }) => {
    const { t } = useTranslation("common");
    const [sucursal_id] = useState(sucursal ? sucursal : getDataSession('sucursal'));
    const [categoriaId, setCategoriaID] = useState('');
    const [categoriaClave, setCategoriaClave] = useState((claveCategoria && claveCategoria !== '') ? claveCategoria : data?.clave_Categoria);
    const [initialObject, setInitialObject] = useState();
    const [initialObject2, setInitialObject2] = useState([]);
    const [categoria, SetCategoria] = useState();

    const loadDataCategoriaPrincipal = async (query) =>
        tienda !== 'MERCADOLIBRE' ? await fetchConToken(`Categorias/GetList?pagina=${0}&totalXpagina=${50}&busqueda=${query}&sucursal_Id=${sucursal_id}&tipo_Categoria=P`)
            : await fetchConToken(`Categorias/GetListMercadoLibre?paginas=${1}&totalXpagina=${50}&busqueda=${query}&categoriaPadre`);

    const loadDataSubCategoria = useCallback(async (query) => {
        await fetchConToken(`Categorias/GetListMercadoLibre?paginas=${1}&totalXpagina=${50}&busqueda=&categoriaPadre=${query}`).then((resp) => {
            setInitialObject2(resp);
            if (resp.length > 0) HandleChangePrincipal('0');
            else HandleChangePrincipal(query);
        });
    }, []);

    const onChange = useCallback((categoria) => {
        setCategoriaID(categoria.clave_Categoria);
        loadDataSubCategoria(categoria.clave_Categoria);
    }, [loadDataSubCategoria]); // Depende de la función de arriba

    const loadDataSubCategoria2 = useCallback(async (query) => {
        await fetchConToken(`Categorias/GetList?paginas=${0}&totalXpagina=${50}&categoriaPadre=${query}&sucursal_Id=${sucursal_id}`).then((resp) => {
            setInitialObject2(resp);
            if (resp.length > 0) HandleChangePrincipal('0');
            else HandleChangePrincipal(query);
        });
    }, []);

    const downloadDataCategoria = useCallback(async (query, index, callbackRecursivo) => {
        await fetchConToken(`Categorias/DescargarCategoria?claveCategoria=${query}&sucursal_Id=${sucursal_id}`).then((resp) => {
            if (index === 1 && callbackRecursivo) callbackRecursivo(query, 2);
        }).catch(() => Swal.fire('Error', `No se encontró la categoría ${query}`, 'error'));
    }, []);

    const loadDataCategoria = useCallback(async (query, index) => {
        await fetchConToken(`Categorias/GetCategoriByHijo?categoria=${query}`).then((resp) => {
            setInitialObject(resp);
            if (resp.sub_Categoria && resp.sub_Categoria.length > 0) onChange(resp);
            else if (index === 1) downloadDataCategoria(query, index);
        });
    }, [downloadDataCategoria, onChange]);

    const PredictCategoria = async (titulo) => await fetchConToken(`Articulos/PredictCategoria?titulo=${titulo}&sucursal_Id=${sucursal_id}`).then((resp) => {
        HandleChangePrincipal(resp.categoriaId);
        loadDataCategoria(resp.categoriaId, 1);
        if (HandlePredictCat) HandlePredictCat(resp.categoriaId);
    });

    const subCat = () => {
        if (initialObject.sub_Categoria?.length > 0) return initialObject.sub_Categoria[0];

        return null;
    }

    function ActualizarCategoria() {
        if (data) PredictCategoria(data.nombre);
    }

    function AddCategoria(e) {
        var aux = categorias.find((item) => item.clave_Categoria === categoria?.clave_Categoria);
        if (aux) return;

        if (data && data.id && data.id > 0) {
            if (tienda === 'SHOPIFY') {
                SetCategorias([...categorias, categoria], categoria, true);
                return;
            }

            fetchConToken(`Articulos/ArticuloCategoria`, { clave_Categoria: categoria.clave_Categoria, articulo_Id: data.id }, 'POST').then((res) => {
                if (res.hasOwnProperty('status')) {
                    Object.entries(res?.errors).forEach(([, value]) => {
                        Swal.fire('Error', value[0], 'error');
                    });
                    return false;
                } else if (res.hasOwnProperty('codigo') && res.codigo !== 200) {
                    Swal.fire('Error', res.mensajes[0], 'error');
                    return false;
                }

                SetCategorias([...categorias, categoria], categoria, true);
            });
        }
        else SetCategorias([...categorias, categoria], categoria, true);
    }

    function EliminarCategoria(cat) {
        if (cat) {
            if (data.id && data.id > 0) {
                if (tienda === 'SHOPIFY') {
                    SetCategorias(categorias.filter((item) => item.clave_Categoria !== cat.clave_Categoria), cat, false);
                    return;
                }

                fetchConToken(`Articulos/ArticuloCategorias?articulo_id=${data.id}&Clave_Etiqueta=${cat.clave_Categoria}`, null, 'DELETE').then((res) => {
                    if (res.hasOwnProperty('status')) {
                        Object.entries(res?.errors).forEach(([, value]) => {
                            Swal.fire('Error', value[0], 'error');
                        });
                        return false;
                    } else if (res.hasOwnProperty('codigo')) {
                        Swal.fire('Error', res.mensajes[0], 'error');
                        return;
                    }

                    SetCategorias(categorias.filter((item) => item.clave_Categoria !== cat.clave_Categoria), cat, false);
                });
            }
            else SetCategorias(categorias.filter((item) => item.clave_Categoria !== cat.clave_Categoria), cat, false);
        }
    }

    const GetSelect = () => {
        if (!disabled) return (<div className='col-md-12' style={{ display: 'grid' }}>
            <div className='row'>
                <div className='col-sm-8' style={{ display: 'grid' }}>
                    <AsyncSelect
                        isClearable
                        className='react-select-placeholder'
                        getOptionLabel={(option) => option.clave_Categoria + ' - ' + option.nombre}
                        getOptionValue={(option) => option.clave_Categoria}
                        defaultOptions
                        value={initialObject}
                        isDisabled={disabled}
                        loadOptions={loadDataCategoriaPrincipal}
                        onChange={(selectedItem) => {
                            const val = selectedItem === null ? '' : selectedItem?.clave_Categoria;
                            setInitialObject(selectedItem);
                            setCategoriaID(val);
                            loadDataSubCategoria(val);
                        }}
                    />
                </div>
                <div className='col-sm-4' style={{ display: 'grid' }}><button className='btn btn-outline-info' type='button' onClick={(e) => ActualizarCategoria()}>Categorizacion Automatica</button></div>
            </div>
        </div>);

        return (<AsyncSelect
            isClearable
            className='react-select-placeholder'
            getOptionLabel={(option) => option.clave_Categoria + ' - ' + option.nombre}
            getOptionValue={(option) => option.clave_Categoria}
            defaultOptions
            value={initialObject}
            isDisabled={disabled}
            loadOptions={loadDataCategoriaPrincipal}
            onChange={(selectedItem) => {
                const val = selectedItem === null ? '' : selectedItem?.clave_Categoria;
                setInitialObject(selectedItem);
                setCategoriaID(val);
                loadDataSubCategoria(val);
            }}
        />);
    }

    useEffect(() => {
        if (tienda === 'MERCADOLIBRE' && (categoriaClave && categoriaClave !== '' && categoriaClave !== '0')) loadDataCategoria(categoriaClave, 1);
    }, []);

    return tienda !== 'MERCADOLIBRE' ? (<div className='col-md-12' style={{ display: 'grid' }}>
        <div className='row'>
            <div className='col-sm-6' style={{ display: 'grid' }}>
                <label htmlFor='clave_cat_principal' className='form-label'> {t('app.Articulos.form.categoriaPpal')}</label>
                <AsyncSelect
                    isClearable
                    className='react-select-placeholder'
                    getOptionLabel={(option) => option.clave_Categoria + ' - ' + option.nombre}
                    getOptionValue={(option) => option.clave_Categoria}
                    defaultOptions
                    value={initialObject}
                    isDisabled={disabled}
                    loadOptions={loadDataCategoriaPrincipal}
                    onChange={(selectedItem) => {
                        const val = selectedItem === null ? '' : selectedItem?.clave_Categoria;
                        setInitialObject(selectedItem);
                        setCategoriaID(val);
                        loadDataSubCategoria2(val);
                        if (selectedItem) SetCategoria(selectedItem);
                    }}
                />
                {(categoriaId !== '' && initialObject2.length > 0) &&
                    (<CategoriaSelect index={1} Categoria={subCat} Categorias={initialObject2} HandleChangePrincipal={HandleChangePrincipal} disabled={disabled} SetCategoria={SetCategoria} tienda={tienda} sucursal={sucursal_id} />)}
                <div className='espacio15px' />
                <div><button className='btn btn-outline-info' type='button' onClick={AddCategoria}>Asignar categoria</button></div>
            </div>
            <div className='card col-sm-6' style={{ display: 'grid' }}>
                <div className='card-body'>
                    <div style={{ overflowX: 'auto' }}>
                        <table className='table'>
                            <thead>
                                <tr>
                                    <th className='text-center'>Clave</th>
                                    <th className='text-center'>Categoria</th>
                                    <th className='text-right' width='50' />
                                </tr>
                            </thead>
                            <tbody>
                                {categorias?.map(item => {
                                    return (
                                        <tr key={item.id}>
                                            <td className='text-center'>{item.clave_Categoria}</td>
                                            <td className='text-center'>{item.nombre}</td>
                                            <td className='text-center' width='50'>
                                                <button type='button' className='btn' style={{ color: 'red' }} onClick={(e) => EliminarCategoria(item)}>
                                                    <svg
                                                        xmlns='http://www.w3.org/2000/svg'
                                                        width='25'
                                                        height='20'
                                                        fill='currentColor'
                                                        className='bi bi-x-circle-fill'
                                                        viewBox='0 0 16 16'
                                                    >
                                                        <path d='M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z'></path>
                                                    </svg>
                                                </button>
                                            </td>
                                        </tr>);
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
    ) : (<>
        <label htmlFor='clave_cat_principal' className='form-label'> {t('app.Articulos.form.categoriaPpal')}</label>
        {GetSelect()}
        {(categoriaId !== '' && initialObject2.length > 0) && (<CategoriaSelect index={1} Categoria={subCat} Categorias={initialObject2} HandleChangePrincipal={HandleChangePrincipal} disabled={disabled} tienda={tienda} sucursal={sucursal_id} />)}
    </>);
}

const CategoriaSelect = ({ index, Categoria, Categorias, HandleChangePrincipal, disabled, SetCategoria, tienda, sucursal }) => {
    const { t } = useTranslation("common");
    const [sucursal_id] = useState(sucursal ? sucursal : getDataSession('sucursal'));
    const [categoriaId, setCategoriaID] = useState('');
    const [initialObject, setInitialObject] = useState(Categoria);
    const [initialObject2, setInitialObject2] = useState([]);

    const loadDataSubCategoria = useCallback(async (query) => {
        await fetchConToken(`Categorias/GetListMercadoLibre?paginas=${1}&totalXpagina=${50}&busqueda=&categoriaPadre=${query}`).then((resp) => {
            setInitialObject2(resp);
            if (resp.length > 0) HandleChangePrincipal('0');
            else HandleChangePrincipal(query);
        });
    }, [HandleChangePrincipal]);

    const loadDataSubCategoria2 = useCallback(async (query) => {
        await fetchConToken(`Categorias/GetList?paginas=${0}&totalXpagina=${50}&categoriaPadre=${query}&sucursal_Id=${sucursal_id}`).then((resp) => {
            setInitialObject2(resp);
            if (resp.length > 0) HandleChangePrincipal('0');
            else HandleChangePrincipal(query);
        });
    }, [HandleChangePrincipal, sucursal_id]);

    const subCat = () => {
        if (initialObject.sub_Categoria?.length > 0) return initialObject.sub_Categoria[0];
        return null;
    }

    function handleChange(e) {
        setCategoriaID(e.target.value);
        var aux = Categorias.filter((item) => item.clave_Categoria === e.target.value);
        if (aux.length > 0) {
            var cat = aux[0];
            setInitialObject(cat);
            if (tienda === 'MERCADOLIBRE') loadDataSubCategoria(e.target.value);
            else {
                loadDataSubCategoria2(e.target.value);
                if (SetCategoria) SetCategoria(cat);
            }
        }
    }

    useEffect(() => {
        if (initialObject && initialObject.clave_Categoria && initialObject.clave_Categoria !== '' && initialObject.clave_Categoria !== '0') {
            setCategoriaID(initialObject.clave_Categoria);
            if (tienda === 'MERCADOLIBRE') loadDataSubCategoria(initialObject.clave_Categoria);
            else loadDataSubCategoria2(initialObject.clave_Categoria);
        }
    }, [initialObject]);

    return (
        <>
            <label htmlFor='SubCategoria' className='form-label'> {t('app.Articulos.form.subCategoria') + ' ' + index}</label>
            <select className={!disabled ? 'form-select' : 'form-select form-control-disabled'} name='SubCategoria' value={initialObject?.clave_Categoria || '0'} onChange={handleChange} disabled={disabled}>
                <option key={0} value='0'>{t('app.Articulos.form.seleccioneSubCat')}</option>
                {Categorias.map((item) => { return (<option key={item.clave_Categoria} value={item.clave_Categoria}>{item.clave_Categoria + ' - ' + item.nombre}</option>); })}
            </select>
            {(categoriaId !== '' && initialObject2.length > 0) &&
                (<CategoriaSelect index={(index + 1)} Categoria={subCat} Categorias={initialObject2} HandleChangePrincipal={HandleChangePrincipal} disabled={disabled} SetCategoria={SetCategoria} tienda={tienda} sucursal={sucursal_id} />)}
        </>
    );
}

const AtributoList = ({ disabled, atributos, SetAtributos, sucursal }) => {
    const [initialObject, setInitialObject] = useState();
    const [atributo, SetAtributo] = useState();
    const [sucursal_id] = useState(sucursal ? sucursal : getDataSession('sucursal'));
    const loadDataAtributos = async (query) => await fetchConToken(`Categorias/AtributosListBySucursal?pagina=${1}&totalXpagina=${50}&busqueda=${query}&sucursal_Id=${sucursal_id}`);

    function AddAtributo(e) {
        var aux = atributos.find((item) => item.clave_Atributo === atributo?.clave_Atributo);
        if (aux) return;

        SetAtributos([...atributos, atributo]);
    }

    function EliminarAtributo(atributo) {
        if (atributo) SetAtributos(atributos.filter((item) => item.clave_Atributo !== atributo.clave_Atributo));
    }

    return (
        <div className='col-md-12' style={{ display: 'grid' }}>
            <div className='row'>
                <div className='col-sm-6' style={{ display: 'grid' }}>
                    <label htmlFor='clave_cat_principal' className='form-label'>Atributo</label>
                    <AsyncSelect
                        isClearable
                        className='react-select-placeholder'
                        getOptionLabel={(option) => option.clave_Atributo + ' - ' + option.nombre}
                        getOptionValue={(option) => option.clave_Atributo}
                        defaultOptions
                        value={initialObject}
                        isDisabled={disabled}
                        loadOptions={loadDataAtributos}
                        onChange={(selectedItem) => {
                            setInitialObject(selectedItem);
                            if (selectedItem) SetAtributo(selectedItem);
                        }}
                    />
                    <div className='espacio15px' />
                    <div><button className='btn btn-outline-info' type='button' onClick={AddAtributo}>Asignar atributo</button></div>
                </div>
                <div className='card col-sm-6' style={{ display: 'grid' }}>
                    <div className='card-body'>
                        <div style={{ overflowX: 'auto' }}>
                            <table className='table'>
                                <thead>
                                    <tr>
                                        <th className='text-center'>Clave</th>
                                        <th className='text-center'>Atributo</th>
                                        <th className='text-right' width='50' />
                                    </tr>
                                </thead>
                                <tbody>
                                    {atributos?.map(item => {
                                        return (
                                            <tr key={item.id}>
                                                <td className='text-center'>{item.clave_Atributo}</td>
                                                <td className='text-center'>{item.nombre}</td>
                                                <td className='text-center' width='50'>
                                                    <button type='button' className='btn' style={{ color: 'red' }} onClick={(e) => EliminarAtributo(item)}>
                                                        <svg
                                                            xmlns='http://www.w3.org/2000/svg'
                                                            width='25'
                                                            height='20'
                                                            fill='currentColor'
                                                            className='bi bi-x-circle-fill'
                                                            viewBox='0 0 16 16'
                                                        >
                                                            <path d='M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z'></path>
                                                        </svg>
                                                    </button>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

const MedidasEnvio = ({ articulo, handleInputChange, disabled, tienda, sucursal }) => {
    return (<div className='col-md-10' style={{ display: 'grid' }}>
        <div className='row'>
            <label htmlFor='clave_cat_principal' className='form-label'>Medidas</label>
            {tienda !== 'SHOPIFY' && <div className='col-sm-6' style={{ display: 'grid' }}>
                <label htmlFor='peso' className='form-label'>Peso</label>
                <input
                    type='number'
                    inputmode='decimal'
                    className='form-control'
                    name='peso'
                    maxLength={100}
                    value={articulo.peso || '0'}
                    onChange={handleInputChange}
                />
                <label htmlFor='longitud' className='form-label'>Longitud</label>
                <input
                    type='number'
                    inputmode='decimal'
                    className='form-control'
                    name='longitud'
                    maxLength={100}
                    value={articulo.longitud || '0'}
                    onChange={handleInputChange}
                />
                <label htmlFor='ancho' className='form-label'>Ancho</label>
                <input
                    type='number'
                    inputmode='decimal'
                    className='form-control'
                    name='ancho'
                    maxLength={100}
                    value={articulo.ancho || '0'}
                    onChange={handleInputChange}
                />
                <label htmlFor='altura' className='form-label'>Alto</label>
                <input
                    type='number'
                    inputmode='decimal'
                    className='form-control'
                    name='altura'
                    maxLength={100}
                    value={articulo.altura || '0'}
                    onChange={handleInputChange}
                />
                <div className='espacio5px' />
            </div>}
            {tienda === 'SHOPIFY' && <div className='col-sm-6' style={{ display: 'grid' }}>
                <label htmlFor='peso' className='form-label'>Peso</label>
                <input
                    type='number'
                    inputmode='decimal'
                    className='form-control'
                    name='peso'
                    maxLength={100}
                    value={articulo.peso || '0'}
                    onChange={handleInputChange}
                />
                <div className='espacio5px' />
            </div>}
        </div>
    </div>);
}

const EtiquetasList = ({ disabled, etiquetas, SetEtiquetas, sucursal }) => {
    const [initialObject, setInitialObject] = useState();
    const [etiqueta, SetEtiqueta] = useState();
    const [sucursal_id] = useState(sucursal ? sucursal : getDataSession('sucursal'));
    const loadDataEtiquetas = async (query) => await fetchConToken(`Categorias/EtiquetaList?pagina=${1}&totalXpagina=${50}&busqueda=${query}&sucursal_Id=${sucursal_id}`);

    function AddEtiquetas(e) {
        var aux = etiquetas.find((item) => item.clave_Etiqueta === etiqueta?.clave_Etiqueta);
        if (aux) return;

        SetEtiquetas([...etiquetas, etiqueta]);
    }

    function EliminarEtiqueta(etiqueta) {
        if (etiqueta) SetEtiquetas(etiquetas.filter((item) => item.clave_Etiqueta !== etiqueta.clave_Etiqueta));
    }

    return (
        <div className='col-md-12' style={{ display: 'grid' }}>
            <div className='row'>
                <div className='col-sm-6' style={{ display: 'grid' }}>
                    <label htmlFor='clave_cat_principal' className='form-label'>Etiqueta</label>
                    <AsyncSelect
                        isClearable
                        className='react-select-placeholder'
                        getOptionLabel={(option) => option.clave_Etiqueta + ' - ' + option.nombre}
                        getOptionValue={(option) => option.clave_Etiqueta}
                        defaultOptions
                        value={initialObject}
                        isDisabled={disabled}
                        loadOptions={loadDataEtiquetas}
                        onChange={(selectedItem) => {
                            setInitialObject(selectedItem);
                            if (selectedItem) SetEtiqueta(selectedItem);
                        }}
                    />
                    <div className='espacio15px' />
                    <div><button className='btn btn-outline-info' type='button' onClick={AddEtiquetas}>Asignar etiqueta</button></div>
                </div>
                <div className='card col-sm-6' style={{ display: 'grid' }}>
                    <div className='card-body'>
                        <div style={{ overflowX: 'auto' }}>
                            <table className='table'>
                                <thead>
                                    <tr>
                                        <th className='text-center'>Clave</th>
                                        <th className='text-center'>Etiqueta</th>
                                        <th className='text-right' width='50' />
                                    </tr>
                                </thead>
                                <tbody>
                                    {etiquetas?.map(item => {
                                        return (
                                            <tr key={item.id}>
                                                <td className='text-center'>{item.clave_Etiqueta}</td>
                                                <td className='text-center'>{item.nombre}</td>
                                                <td className='text-center' width='50'>
                                                    <button type='button' className='btn' style={{ color: 'red' }} onClick={(e) => EliminarEtiqueta(item)}>
                                                        <svg
                                                            xmlns='http://www.w3.org/2000/svg'
                                                            width='25'
                                                            height='20'
                                                            fill='currentColor'
                                                            className='bi bi-x-circle-fill'
                                                            viewBox='0 0 16 16'
                                                        >
                                                            <path d='M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z'></path>
                                                        </svg>
                                                    </button>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export { FormCategoriaXLotes, FormCategoria, CategoriaList, AtributoList, MedidasEnvio, EtiquetasList };